<div>
  <div class="strong-text" *ngIf="!!issue.operation">
    {{ productName }} encountered an access issue when attempting the {{ issue.operation }} operation in one of your
    environments. Review the message below for more details. The error may be due to your access templates being out of
    date. If so, use the link below to update them.
  </div>
  <div class="strong-text" *ngIf="!issue.operation">
    {{ productName }} encountered an access issue when attempting to connect to one of your environments. Review the
    message below for more details. The error may be due to your access templates being out of date. If so, use the link
    below to update them.
  </div>

  <div class="padding-top" *ngIf="issue.message">
    <p-scrollPanel [style]="{ width: '100%', height: '200px' }" styleClass="content-custom-scrollbar">
      <pre><div class="code small">{{ issue.message | truncateErrorMessagePipe }}</div></pre>
    </p-scrollPanel>
  </div>

  <div class="padding-top">
    <a href="" (click)="showAccessDialog($event)">Click here to update your access templates</a>
  </div>
</div>

<modal-dialog #updateAccessDialog [dialogTemplate]="updateAccessDialogTemplate"></modal-dialog>

<ng-template #updateAccessDialogTemplate>
  <update-access-dialog
    [applicationType]="applicationType"
    [sourceEndpointUri]="sourceEndpointUri"
    [targetEndpointUri]="targetEndpointUri"
    (done)="dismissAccessDialog()"
    (cancel)="dismissAccessDialog()"
  ></update-access-dialog>
</ng-template>
